import axios from "axios";

function getMotoModels(idCD, marca, anio, polkoClientes) {
    let carVersionsUrl = process.env.REACT_APP_BACK_SERVER + '/getVersionesMotos'
    return axios.get(carVersionsUrl, {
        params: {
            'idcanaldigital': idCD,
            'marca': marca,
            'anio': anio,
            ...(polkoClientes && { origen: "polko_clients" }),
        }
    });
}

export default getMotoModels;